/**
 * Converts a lower case string to upper case. For example, "foo" would be converted to "Foo".
 */
export function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}
